export const HELIX_APP_STORE_LINK =
  'https://apps.apple.com/us/app/helix-trade-with-control/id6737353178'

export const HELIX_PLAY_STORE_LINK =
  'https://play.google.com/store/apps/details?id=com.injectivelabs.helixmobile'
